export const ToolRendererEnum = Object.freeze({
	LINKED_REQUIREMENTS_CONFIG: "linkedRequirementsConfigRenderer",
	LINKED_REQUIREMENTS_WORK: "linkedRequirementsWorkRenderer",
	LINKED_REQUIREMENTS_RESULT: "linkedRequirementsResultRenderer",
	LINKED_REQUIREMENTS_BLANK_PRINT: "linkedRequirementsBlankPrintRenderer",
	LINKED_REQUIREMENTS_RESULT_PRINT: "linkedRequirementsResultPrintRenderer",
	PAIRED_QUESTIONNAIRE_CONFIG: "pairedQuestionnaireConfigRenderer",
	PAIRED_QUESTIONNAIRE_WORK: "pairedQuestionnaireWorkRenderer",
	PAIRED_QUESTIONNAIRE_RESULT: "pairedQuestionnaireResultRenderer",
	PAIRED_QUESTIONNAIRE_BLANK_PRINT: "pairedQuestionnaireBlankPrintRenderer",
	PAIRED_QUESTIONNAIRE_RESULT_PRINT: "pairedQuestionnaireResultPrintRenderer",
	FORM_STRUCTURED_CONFIG: "formStructuredConfigRenderer",
	FORM_STRUCTURED_WORK: "formStructuredWorkRenderer",
	FORM_STRUCTURED_RESULT: "formStructuredResultRenderer",
	FORM_STRUCTURED_BLANK_PRINT: "formStructuredBlankPrintRenderer",
	FORM_STRUCTURED_RESULT_PRINT: "formStructuredResultPrintRenderer",
	CONTEXT_MAP_CONFIG: "contextMapConfigRenderer",
	CONTEXT_MAP_WORK: "contextMapWorkRenderer",
	CONTEXT_MAP_RESULT: "contextMapResultRenderer",
	CONTEXT_MAP_BLANK_PRINT: "contextMapBlankPrintRenderer",
	CONTEXT_MAP_RESULT_PRINT: "contextMapResultPrintRenderer",
	ANCHORED_MEAN_CONFIG: "anchoredMeanConfigRenderer",
	ANCHORED_MEAN_WORK: "anchoredMeanWorkRenderer",
	ANCHORED_MEAN_RESULT: "anchoredMeanResultRenderer",
	ANCHORED_MEAN_BLANK_PRINT: "anchoredMeanBlankPrintRenderer",
	ANCHORED_MEAN_RESULT_PRINT: "anchoredMeanResultPrintRenderer",
	SCRIPT_WORKSHEET_CONFIG: "scriptWorksheetConfigRenderer",
	SCRIPT_WORKSHEET_WORK: "scriptWorksheetWorkRenderer",
	SCRIPT_WORKSHEET_RESULT: "scriptWorksheetResultRenderer",
	SCRIPT_WORKSHEET_BLANK_PRINT: "scriptWorksheetBlankPrintRenderer",
	SCRIPT_WORKSHEET_RESULT_PRINT: "scriptWorksheetResultPrintRenderer",
	RITUAL_HANDOUT_CONFIG: "ritualHandoutConfigRenderer",
	RITUAL_HANDOUT_WORK: "ritualHandoutWorkRenderer",
	RITUAL_HANDOUT_RESULT: "ritualHandoutResultRenderer",
	RITUAL_HANDOUT_BLANK_PRINT: "ritualHandoutBlankPrintRenderer",
	RITUAL_HANDOUT_RESULT_PRINT: "ritualHandoutResultPrintRenderer",
	ORDINAL_PROFILE_CONFIG: "ordinalProfileConfigRenderer",
	ORDINAL_PROFILE_WORK: "ordinalProfileWorkRenderer",
	ORDINAL_PROFILE_RESULT: "ordinalProfileResultRenderer",
	ORDINAL_PROFILE_BLANK_PRINT: "ordinalProfileBlankPrintRenderer",
	ORDINAL_PROFILE_RESULT_PRINT: "ordinalProfileResultPrintRenderer",
	FORM_TARGET_CONFIG: "formTargetConfigRenderer",
	FORM_RULER_CONFIG: "formRulerConfigRenderer",
	FORM_RULER_WORK: "formRulerWorkRenderer",
	FORM_RULER_RESULT: "formRulerResultRenderer",
	FORM_RULER_BLANK_PRINT: "formRulerBlankPrintRenderer",
	FORM_RULER_RESULT_PRINT: "formRulerResultPrintRenderer",
	DISCRETE_RATING_CONFIG: "discreteRatingConfigRenderer",
	DISCRETE_RATING_WORK: "discreteRatingWorkRenderer",
	DISCRETE_RATING_RESULT: "discreteRatingResultRenderer",
	DISCRETE_RATING_BLANK_PRINT: "discreteRatingBlankPrintRenderer",
	DISCRETE_RATING_RESULT_PRINT: "discreteRatingResultPrintRenderer",
	FORM_TARGET_WORK: "formTargetWorkRenderer",
	FORM_TARGET_RESULT: "formTargetResultRenderer",
	FORM_TARGET_BLANK_PRINT: "formTargetBlankPrintRenderer",
	FORM_TARGET_RESULT_PRINT: "formTargetResultPrintRenderer",
	PATTERN_PROFILE_CONFIG: "patternProfileConfigRenderer",
	PATTERN_PROFILE_WORK: "patternProfileWorkRenderer",
	PATTERN_PROFILE_RESULT: "patternProfileResultRenderer",
	PATTERN_PROFILE_BLANK_PRINT: "patternProfileBlankPrintRenderer",
	PATTERN_PROFILE_RESULT_PRINT: "patternProfileResultPrintRenderer",
	REFLECTIVE_STATEMENT_CONFIG: "reflectiveStatementConfigRenderer",
	REFLECTIVE_STATEMENT_WORK: "reflectiveStatementWorkRenderer",
	REFLECTIVE_STATEMENT_RESULT: "reflectiveStatementResultRenderer",
	REFLECTIVE_STATEMENT_BLANK_PRINT: "reflectiveStatementBlankPrintRenderer",
	REFLECTIVE_STATEMENT_RESULT_PRINT: "reflectiveStatementResultPrintRenderer",
	POSITION_MAP_CONFIG: "positionMapConfigRenderer",
	POSITION_MAP_WORK: "positionMapWorkRenderer",
	POSITION_MAP_RESULT: "positionMapResultRenderer",
	POSITION_MAP_BLANK_PRINT: "positionMapBlankPrintRenderer",
	POSITION_MAP_RESULT_PRINT: "positionMapResultPrintRenderer",
	NARRATIVE_INTERVIEW_CONFIG: "narrativeInterviewConfigRenderer",
	NARRATIVE_INTERVIEW_WORK: "narrativeInterviewWorkRenderer",
	NARRATIVE_INTERVIEW_RESULT: "narrativeInterviewResultRenderer",
	NARRATIVE_INTERVIEW_BLANK_PRINT: "narrativeInterviewBlankPrintRenderer",
	NARRATIVE_INTERVIEW_RESULT_PRINT: "narrativeInterviewResultPrintRenderer",
	ANALYTICS_CORRELATION_RESULT: "analyticsCorrelationResultRenderer",
	ANALYTICS_CORRELATION_WORK: "analyticsCorrelationWorkRenderer",
	ANALYTICS_SOURCE_CONFIG: "analyticsSourceConfigRenderer",
	BAR_LIST_PROFILE_RESULT: "barListProfileResultRenderer",
	BUILDER_ARTIFACT_RESULT: "builderArtifactResultRenderer",
	BUILDER_ARTIFACT_WORK: "builderArtifactWorkRenderer",
	BUILDER_CARD_ARTIFACT_WORK: "builderCardArtifactWorkRenderer",
	BUILDER_DIALOGUE_WORK: "builderDialogueWorkRenderer",
	BUILDER_LETTER_WORK: "builderLetterWorkRenderer",
	BUILDER_SCHEDULE_WORK: "builderScheduleWorkRenderer",
	BUILDER_SCRIPT_WORK: "builderScriptWorkRenderer",
	BUILDER_TEMPLATE_CONFIG: "builderTemplateConfigRenderer",
	BULLSEYE_PROFILE_RESULT: "bullseyeProfileResultRenderer",
	BULLSEYE_PROFILE_WORK: "bullseyeProfileWorkRenderer",
	GRAPH_CANVAS_SCHEMA_CONFIG: "graphCanvasSchemaConfigRenderer",
	GRAPH_CANVAS_STRUCTURED_RESULT: "graphCanvasStructuredResultRenderer",
	GRAPH_CANVAS_TEMPLATE_WORK: "graphCanvasTemplateWorkRenderer",
	CARD_BUCKETS_WORK: "cardBucketsWorkRenderer",
	CARD_GROUPED_RESULT: "cardGroupedResultRenderer",
	CARD_LIST_CONFIG: "cardListConfigRenderer",
	CARD_ORDERED_RESULT: "cardOrderedResultRenderer",
	CARD_PROGRESSIVE_NARROWING_CONFIG: "cardProgressiveNarrowingConfigRenderer",
	CARD_PROGRESSIVE_NARROWING_WORK: "cardProgressiveNarrowingWorkRenderer",
	CARD_SELECTED_RESULT: "cardSelectedResultRenderer",
	CARD_SELECTION_WORK: "cardSelectionWorkRenderer",
	COLLABORATIVE_BOARD_RESULT: "collaborativeBoardResultRenderer",
	COLLABORATIVE_BOARD_WORK: "collaborativeBoardWorkRenderer",
	COLLABORATIVE_MEETING_WORK: "collaborativeMeetingWorkRenderer",
	COMPASS_PROFILE_RESULT: "compassProfileResultRenderer",
	COMPASS_PROFILE_WORK: "compassProfileWorkRenderer",
	CONCENTRIC_BUCKETS_WORK: "concentricBucketsWorkRenderer",
	CONTINUUM_RESULT: "continuumResultRenderer",
	CONTINUUM_WORK: "continuumWorkRenderer",
	CREATIVE_CANVAS_COMIC_WORK: "creativeCanvasComicWorkRenderer",
	CREATIVE_CANVAS_CONFIG: "creativeCanvasConfigRenderer",
	CREATIVE_CANVAS_RESULT: "creativeCanvasResultRenderer",
	CREATIVE_CANVAS_SANDTRAY_WORK: "creativeCanvasSandtrayWorkRenderer",
	CREATIVE_CANVAS_WORK: "creativeCanvasWorkRenderer",
	CRITERIA_MATRIX_RESULT: "criteriaMatrixResultRenderer",
	CRITERIA_MATRIX_WORK: "criteriaMatrixWorkRenderer",
	EXPERIMENT_COMPARISON_RESULT: "experimentComparisonResultRenderer",
	EXPERIMENT_CONFIG: "experimentConfigRenderer",
	EXPERIMENT_LEARNING_RESULT: "experimentLearningResultRenderer",
	EXPERIMENT_PLAN_OUTCOME_WORK: "experimentPlanOutcomeWorkRenderer",
	GRAPH_CHAIN_BLANK_PRINT: "graphChainBlankPrintRenderer",
	GRAPH_CHAIN_RESULT_PRINT: "graphChainResultPrintRenderer",
	GRAPH_CHAIN_WORK: "graphChainWorkRenderer",
	GRAPH_CHAIN_CONFIG: "graphChainConfigRenderer",
	GRAPH_CHAIN_RESULT: "graphChainResultRenderer",
	FORM_SCORE_RESULT: "formScoreResultRenderer",
	CLINICIAN_ASSESSMENT_CONFIG: "clinicianAssessmentConfigRenderer",
	CLINICIAN_ASSESSMENT_RESULT: "clinicianAssessmentResultRenderer",
	CLINICIAN_ASSESSMENT_WORK: "clinicianAssessmentWorkRenderer",
	CLINICIAN_ASSESSMENT_RESULT_PRINT: "clinicianAssessmentResultPrintRenderer",
	CLINICIAN_ASSESSMENT_BLANK_PRINT: "clinicianAssessmentBlankPrintRenderer",
	COIS_R_CONFIG: "coisRConfigRenderer",
	SUBSCALE_PROFILE_CONFIG: "subscaleProfileConfigRenderer",
	SUBSCALE_PROFILE_WORK: "subscaleProfileWorkRenderer",
	SUBSCALE_PROFILE_RESULT: "subscaleProfileResultRenderer",
	SUBSCALE_PROFILE_BLANK_PRINT: "subscaleProfileBlankPrintRenderer",
	SUBSCALE_PROFILE_RESULT_PRINT: "subscaleProfileResultPrintRenderer",
	COIS_R_WORK: "coisRWorkRenderer",
	COIS_R_RESULT: "coisRResultRenderer",
	COIS_R_BLANK_PRINT: "coisRBlankPrintRenderer",
	COIS_R_RESULT_PRINT: "coisRResultPrintRenderer",
	FREQUENCY_INVENTORY_CONFIG: "frequencyInventoryConfigRenderer",
	FREQUENCY_INVENTORY_WORK: "frequencyInventoryWorkRenderer",
	FREQUENCY_INVENTORY_RESULT: "frequencyInventoryResultRenderer",
	FREQUENCY_INVENTORY_BLANK_PRINT: "frequencyInventoryBlankPrintRenderer",
	FREQUENCY_INVENTORY_RESULT_PRINT: "frequencyInventoryResultPrintRenderer",
	FORM_STANDARD_BLANK_PRINT: "formStandardBlankPrintRenderer",
	FORM_STANDARD_CONFIG: "formStandardConfigRenderer",
	FORM_STANDARD_RESULT_PRINT: "formStandardResultPrintRenderer",
	FORM_STANDARD_RESULT: "formStandardResultRenderer",
	FORM_STANDARD_WORK: "formStandardWorkRenderer",
	GAME_BINGO_WORK: "gameBingoWorkRenderer",
	GAME_BOARD_WORK: "gameBoardWorkRenderer",
	GAME_MATCHING_WORK: "gameMatchingWorkRenderer",
	GAME_RULES_CONFIG: "gameRulesConfigRenderer",
	GAME_SESSION_RESULT: "gameSessionResultRenderer",
	GAME_SESSION_WORK: "gameSessionWorkRenderer",
	HIERARCHY_CONFIG: "hierarchyConfigRenderer",
	HIERARCHY_GRADED_WORK: "hierarchyGradedWorkRenderer",
	HIERARCHY_ITEMS_CONFIG: "hierarchyItemsConfigRenderer",
	HIERARCHY_PROGRESS_RESULT: "hierarchyProgressResultRenderer",
	HIERARCHY_TREE_WORK: "hierarchyTreeWorkRenderer",
	KANBAN_BOARD_WORK: "kanbanBoardWorkRenderer",
	MULTI_RESPONSE_AGGREGATE_RESULT: "multiResponseAggregateResultRenderer",
	MULTI_RESPONSE_CARD_SORT_WORK: "multiResponseCardSortWorkRenderer",
	MULTI_RESPONSE_COMPARISON_RESULT: "multiResponseComparisonResultRenderer",
	MULTI_RESPONSE_CRITERIA_WORK: "multiResponseCriteriaWorkRenderer",
	MULTI_RESPONSE_EXCHANGE_WORK: "multiResponseExchangeWorkRenderer",
	MULTI_RESPONSE_FORM_WORK: "multiResponseFormWorkRenderer",
	MULTI_RESPONSE_VOTING_WORK: "multiResponseVotingWorkRenderer",
	PROFILE_DIMENSION_CONFIG: "profileDimensionConfigRenderer",
	PROFILE_BLANK_PRINT: "profileBlankPrintRenderer",
	PROFILE_RESULT_PRINT: "profileResultPrintRenderer",
	QUADRANT_RESULT: "quadrantResultRenderer",
	QUADRANT_WORK: "quadrantWorkRenderer",
	SLIDER_LIST_PROFILE_WORK: "sliderListProfileWorkRenderer",
	STAGED_WORKSHEET_CONFIG: "stagedWorksheetConfigRenderer",
	STAGED_WORKSHEET_BLANK_PRINT: "stagedWorksheetBlankPrintRenderer",
	STAGED_WORKSHEET_RESULT_PRINT: "stagedWorksheetResultPrintRenderer",
	STAGED_WORKSHEET_WORK: "stagedWorksheetWorkRenderer",
	STAGED_WORKSHEET_RESULT: "stagedWorksheetResultRenderer",
	RELATIONSHIP_INVENTORY_CONFIG: "relationshipInventoryConfigRenderer",
	RELATIONSHIP_INVENTORY_WORK: "relationshipInventoryWorkRenderer",
	RELATIONSHIP_INVENTORY_RESULT: "relationshipInventoryResultRenderer",
	RELATIONSHIP_INVENTORY_BLANK_PRINT: "relationshipInventoryBlankPrintRenderer",
	RELATIONSHIP_INVENTORY_RESULT_PRINT: "relationshipInventoryResultPrintRenderer",
	EPISODE_SEQUENCE_WORK: "episodeSequenceWorkRenderer",
	EPISODE_SEQUENCE_RESULT: "episodeSequenceResultRenderer",
	EPISODE_SEQUENCE_BLANK_PRINT: "episodeSequenceBlankPrintRenderer",
	EPISODE_SEQUENCE_RESULT_PRINT: "episodeSequenceResultPrintRenderer",
	GRADED_PLAN_CONFIG: "gradedPlanConfigRenderer",
	GRADED_PLAN_WORK: "gradedPlanWorkRenderer",
	GRADED_PLAN_RESULT: "gradedPlanResultRenderer",
	GRADED_PLAN_BLANK_PRINT: "gradedPlanBlankPrintRenderer",
	GRADED_PLAN_RESULT_PRINT: "gradedPlanResultPrintRenderer",
	TIMELINE_CANVAS_WORK: "timelineCanvasWorkRenderer",
	TIMELINE_CHRONOLOGY_RESULT: "timelineChronologyResultRenderer",
	TIMELINE_SCHEMA_CONFIG: "timelineSchemaConfigRenderer",
	IPT_TIMELINE_CONFIG: "iptTimelineConfigRenderer",
	TIMELINE_BLANK_PRINT: "timelineBlankPrintRenderer",
	TIMELINE_RESULT_PRINT: "timelineResultPrintRenderer",
	TIMELINE_DETAIL_CONFIG: "timelineDetailConfigRenderer",
	TIMELINE_DETAIL_WORK: "timelineDetailWorkRenderer",
	TIMELINE_DETAIL_RESULT: "timelineDetailResultRenderer",
	TIMELINE_DETAIL_BLANK_PRINT: "timelineDetailBlankPrintRenderer",
	TIMELINE_DETAIL_RESULT_PRINT: "timelineDetailResultPrintRenderer",
	CANVAS_TIMELINE_CONFIG: "canvasTimelineConfigRenderer",
	CANVAS_TIMELINE_WORK: "canvasTimelineWorkRenderer",
	CANVAS_TIMELINE_RESULT: "canvasTimelineResultRenderer",
	CANVAS_TIMELINE_BLANK_PRINT: "canvasTimelineBlankPrintRenderer",
	CANVAS_TIMELINE_RESULT_PRINT: "canvasTimelineResultPrintRenderer",
	TRACKER_CALENDAR_ENTRY_WORK: "trackerCalendarEntryWorkRenderer",
	TRACKER_ENTRY_CONFIG: "trackerEntryConfigRenderer",
	TRACKER_EPISODE_CONFIG: "trackerEpisodeConfigRenderer",
	TRACKER_EPISODE_WORK: "trackerEpisodeWorkRenderer",
	TRACKER_EPISODE_RESULT: "trackerEpisodeResultRenderer",
	TRACKER_EPISODE_BLANK_PRINT: "trackerEpisodeBlankPrintRenderer",
	TRACKER_EPISODE_RESULT_PRINT: "trackerEpisodeResultPrintRenderer",
	TRACKER_MOMENTARY_CONFIG: "trackerMomentaryConfigRenderer",
	TRACKER_MOMENTARY_WORK: "trackerMomentaryWorkRenderer",
	TRACKER_MOMENTARY_RESULT: "trackerMomentaryResultRenderer",
	TRACKER_MOMENTARY_BLANK_PRINT: "trackerMomentaryBlankPrintRenderer",
	TRACKER_MOMENTARY_RESULT_PRINT: "trackerMomentaryResultPrintRenderer",
	TRACKER_SUDS_CONFIG: "trackerSudsConfigRenderer",
	TRACKER_SUDS_WORK: "trackerSudsWorkRenderer",
	TRACKER_SUDS_RESULT: "trackerSudsResultRenderer",
	TRACKER_SUDS_BLANK_PRINT: "trackerSudsBlankPrintRenderer",
	TRACKER_SUDS_RESULT_PRINT: "trackerSudsResultPrintRenderer",
	TRACKER_ENTRY_WORK: "trackerEntryWorkRenderer",
	TRACKER_QUEUE_WORK: "trackerQueueWorkRenderer",
	TRACKER_SCHEDULED_SESSION_WORK: "trackerScheduledSessionWorkRenderer",
	TRACKER_TREND_RESULT: "trackerTrendResultRenderer",
	TRACKER_WEEKLY_DIARY_CONFIG: "trackerWeeklyDiaryConfigRenderer",
	TRACKER_WEEKLY_DIARY_WORK: "trackerWeeklyDiaryWorkRenderer",
	TRACKER_WEEKLY_DIARY_RESULT: "trackerWeeklyDiaryResultRenderer",
	TRACKER_WEEKLY_DIARY_BLANK_PRINT: "trackerWeeklyDiaryBlankPrintRenderer",
	TRACKER_WEEKLY_DIARY_RESULT_PRINT: "trackerWeeklyDiaryResultPrintRenderer",
	TWO_AXIS_GRID_RESULT: "twoAxisGridResultRenderer",
	TWO_AXIS_GRID_WORK: "twoAxisGridWorkRenderer",
	WEIGHTED_ALLOCATION_RESULT: "weightedAllocationResultRenderer",
	WEIGHTED_ALLOCATION_WORK: "weightedAllocationWorkRenderer",
	WHEEL_PROFILE_RESULT: "wheelProfileResultRenderer",
	WHEEL_PROFILE_WORK: "wheelProfileWorkRenderer",
})
